import { Typography } from "@mui/material";
import React, { useState } from "react";
import ClockIco from "../../../assets/icons/ClockIco";
import Ellipse from "../../../assets/icons/Ellipse";
import ThumbNail from "../../../assets/icons/ThumbnailIco";
import Breadcrumbs from "../../../component/Breadcrumbs";
import {
  CustomDiv,
  WholePageEllipse,
  WholePageOpacity,
} from "../../chat-bot/style";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import { CustomList, CustomListButton } from "../style";

export default function Usermanual() {
  const [selectedData, setSelectedData] = useState({
    loading: true,
    id: 0,
    data: {
      title: "How to Enrich JEM",
      time: "1 min 58 sec",
      id: 0,
      data: "https://www.loom.com/embed/7e9de3f545014868bd5f687b5a549cd0?sid=d83ad5a0-aa5b-4237-a284-e178c621d19d",
    },
  });

  const breadCrumbData = [
    {
      title: "Home",
      navigate: "/home",
    },
    {
      title: "User Manual",
      active: true,
    },
  ];

  const list = [
    {
      title: "How to Enrich JEM",
      time: "1 min 58 sec",
      id: 0,
      data: "https://www.loom.com/embed/7e9de3f545014868bd5f687b5a549cd0?sid=d83ad5a0-aa5b-4237-a284-e178c621d19d",
    },
    {
      title: "How to Create New Job",
      time: "2 min 57 sec",
      id: 1,
      data: "https://www.loom.com/embed/5f4bc50ba1844187bd592658bf298461?sid=44598903-f3b4-442a-b6d7-48b76ff2ba6d",
    },
    {
      title:
        "How to Activate the job and add candidates from the Candidate Hub",
      time: "4 min 18 sec",
      id: 2,
      data: "https://www.loom.com/embed/85bb925a4e8e4c02971a728380228789?sid=ad3c7887-7213-461b-90b9-8ab010b10d95",
    },
    {
      title: "How to Enrich the candidate and save to the Candidate Hub.",
      time: "3 min 3 sec",
      id: 3,
      data: "https://www.loom.com/embed/dd56d9d3a4de4b999877fed117e651f5?sid=3d557807-ed71-4d45-8cf4-16ba99239b44",
    },
    {
      title: "How to Quick Match",
      time: "7 min 22 sec",
      id: 4,
      data: "https://www.loom.com/embed/48172e813ae943ab8fd83bf720b32070?sid=bc739346-3baf-4d22-9efe-43bd00d4ff1d",
    },
    {
      title: "How to Enrich SOW",
      time: "3 min 11 sec",
      id: 5,
      data: "https://www.loom.com/embed/ccde452bc9ce4fd99cd50f7b51416029?sid=d9d18e18-4ea7-49ea-982a-3c2a62a9655a",
    },
    {
      title: "How to SOW Activation and Hailey Chatbot",
      time: "1 min 53 sec",
      id: 6,
      data: "https://www.loom.com/embed/fbf0f9ce84084cb7b7f733a6bd8601ee?sid=4899c644-32c1-4e77-8938-a94490d717e5",
    },
    {
      title: "How to Add Candidates to Activated SOW and Hailey Chatbot",
      time: "7 min 29 sec",
      id: 7,
      data: "https://www.loom.com/embed/6971c207260c4592892285c99631c22b?sid=27cac558-5db3-451d-b64a-83db2f66a158",
    },
    {
      title: "Add Candidate from CHUB to Job using 'Add to Job Pool",
      time: "3 min 7 sec",
      id: 8,
      data: "https://www.loom.com/embed/ab54d38a8f3143098b0b622decc98a99?sid=b707fb17-682e-4ee2-9742-3d13f9a59e43",
    },
    {
      title: "How to Use the Candidates to Jobs",
      time: "4 min 33 sec",
      id: 9,
      data: "https://www.loom.com/embed/cd00ef55987f44a7bc1be330d9886255",
    },
    {
      title: "How to Use the Jobs to Candidates",
      time: "3 min 51 sec",
      id: 10,
      data: "https://www.loom.com/embed/57c5889429bf4f44a3cf7486571c2e0a",
    },
    {
      title: "How to Use the Hiring Manager",
      time: "6 min 23 sec",
      id: 11,
      data: "https://www.loom.com/embed/a9c97040c21e474e9a2ba22cf0461f78",
    },
    {
      title: "How to Use the Golden Record",
      time: "6 min 1 sec",
      id: 12,
      data: "https://www.loom.com/embed/f7434b74772d4f2d8aa1742339cbc038",
    },
    {
      title: "How to Use the Build pipeline",
      time: "6 min 1 sec",
      id: 13,
      data: "https://www.loom.com/embed/b824227518f84797ad32c46466aef2c6",
    },
    {
      title: "How to Use the AI Assist",
      time: "6 min 1 sec",
      id: 14,
      data: "https://www.loom.com/embed/56ec7ab63844415f8d981f20387f16ff",
    },
    {
      title: "How to Use the Dynamic Intelligence  ",
      time: "39 sec",
      id: 15,
      data: " https://www.loom.com/embed/d5c842552e994f7c934233479b35da8b",
    },
    {
      title: "How to Use the Assessment Test Transcipts",
      time: "1 min 13 sec",
      id: 16,
      data: "https://www.loom.com/embed/4737481f51054638a85d0271e30b1bac",
    },
  ];

  const handleClickListVideo = (item) => {
    setSelectedData((prev) => ({
      ...prev,
      loading: true,
      id: item.id,
      data: item,
    }));
  };

  return (
    <CustomDiv padding="2rem">
      <Breadcrumbs breadCrumbData={breadCrumbData} />
      <CommonGrid2
        container
        spacing={2}
        marginTop={"1rem"}
        alignItems={"center"}
      >
        <CommonGrid2 item size={8}>
          <Typography variant="h2" fontWeight={600} marginBottom={"2rem"}>
            {selectedData.data?.title}
          </Typography>
          <div
            style={{
              position: "relative",
              paddingTop: "56.25%",
            }}
          >
            {selectedData.loading && (
              <CustomDiv>
                <WholePageEllipse left="47%">
                  <Ellipse />
                </WholePageEllipse>
                <WholePageOpacity></WholePageOpacity>
              </CustomDiv>
            )}
            <iframe
              src={selectedData.data.data}
              loading="lazy"
              frameBorder="0"
              allowFullScreen
              allow="autoplay; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              onLoad={() =>
                setSelectedData((prev) => ({
                  ...prev,
                  loading: false,
                }))
              }
              title="Loom video"
            ></iframe>
          </div>
        </CommonGrid2>
        <CommonGrid2
          item
          size={4}
          border={"1px solid #EAECEE"}
          borderRadius={"10px"}
          padding={"1rem"}
        >
          <CustomDiv>
            <Typography variant="h5" marginBottom={"0.7rem"}>
              User Manual
            </Typography>
            <CustomList
              width={"calc(100% + 20px)"}
              height={"calc(100vh - 170px)"}
              right={"10px"}
              scrollStyle
              scrollBar="5px"
              scrollBarRadius="10px"
              component="nav"
            >
              <CommonGrid2 container flexDirection={"column"} spacing={1}>
                {list.map((item, index) => (
                  <React.Fragment key={item.title}>
                    <CustomListButton
                      onClick={() => handleClickListVideo(item)}
                      padding={"8px"}
                      borderRadius="5px"
                      background={selectedData.id === item.id ? "#F1E7FF" : ""}
                      selected={selectedData.id === item.id}
                      color={
                        selectedData.id === item.id ? "#6947B0" : "#344054"
                      }
                    >
                      <CommonGrid2 container spacing={2} alignItems={"center"}>
                        <ThumbNail />

                        <CommonGrid2 item flex={1} minWidth={0}>
                          <Typography variant="body4" fontWeight={600}>
                            {item.title}
                          </Typography>
                          <CommonGrid2
                            display={"flex"}
                            alignItems={"center"}
                            gap={"5px"}
                          >
                            <ClockIco />
                            <Typography variant="subtitle2">
                              {item.time}
                            </Typography>
                          </CommonGrid2>
                        </CommonGrid2>
                      </CommonGrid2>
                    </CustomListButton>
                  </React.Fragment>
                ))}
              </CommonGrid2>
            </CustomList>
          </CustomDiv>
        </CommonGrid2>
      </CommonGrid2>
    </CustomDiv>
  );
}
